<template>
  <table class="table status-table" v-if="items && items.length > 0">
    <thead>
      <tr>
        <th>Group Name</th>
        <th>Status</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) of items" :key="index">
        <td>{{ item.group ? item.group.title : "Untitled" }}</td>
        <td>
          {{
            item.latestReview
              ? getReadableStatus(item.latestReview.status)
              : "Not Request"
          }}
        </td>
        <td>
          <a href="javascript:void(0);" @click="onClickEdit(item.platform.id)"
            >Edit</a
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    contentId: {
      type: String,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  watch: {
    contentId() {
      this.load();
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      if (!this.contentId) return;

      const data = await this.$repo.group.getGroupContentApprovalByContentId(
        this.contentId
      );
      this.items = data.results || [];
    },
    reset() {
      this.items = [];
    },
    getReadableStatus(status) {
      switch (status) {
        case "approved":
          return "Confirmed";
        case "rejected":
          return "Rejected";
        case "pending":
          return "Requested";
        default:
          return "Not Request";
      }
    },
    onClickEdit(id) {
      this.$emit("edit", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.status-table {
  width: 100%;
  color: white;
  font-size: 12px;
  max-width: 470px;
  margin: 0 0 20px;

  thead {
    width: 100%;
    th {
      font-weight: bold;

      &:first-child {
        width: 280px;
      }
    }
  }
  th,
  td {
    border: none;
    padding: 5px;
  }

  a {
    color: white;
    text-decoration: underline;
  }
}
</style>